// Importando a store do toolkit
import { configureStore } from '@reduxjs/toolkit'

// Importação do reducer
import layoutReducer from '../reducers/layout-slice'

const store = configureStore({
    reducer: {
        layout: layoutReducer,
    },
})

export default store
